<template>
  <div class="info">
    <h1>Accueil</h1>
    <h3>Vos contacts</h3>
    <p>Vous devez ajouter des contacts afin de pouvoir commencer une conversation.</p>
    <router-link :to="{name:'contacts'}">
      <mdb-btn class="orange darken-1" rounded size="md">Contacts</mdb-btn>
    </router-link>
    <h3>Vos conversations</h3>
    <p>
      Where the magic happens! 
    </p>
    <router-link :to="{name:'myConversations'}">
      <mdb-btn class="orange darken-1" rounded size="md">Conversations</mdb-btn>
    </router-link>

    <h3>Vos questions publiques</h3>
    <p>
      Vous pouvez aussi proposer des questions, ou vous inspirer des questions d'autres personnes
    </p>
    <router-link :to="{name:'allQuestions'}">
      <mdb-btn class="orange darken-1" rounded size="md">Questions</mdb-btn>
    </router-link>
  </div>
</template>

<script>

export default {
  name: "Home",
};
</script>